/**
 *
 * @module introPrice
 *
 */

import Check from 'check-types';

import Exception from './../exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    number,
    nonEmptyString,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class IntroPrice
 * @desc Defines introductory pricing and free trial information for IAP products.
 *
 */
export default class IntroPrice {

    /**
     *
     * @param {Object} options
     * @param {Number} options.length
     * @param {Number} options.price
     * @param {String<SDK.Services.Paywall.TimeUnit>} options.unit
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: `${this.constructor.name}(options)`,
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get length() {
                return `${this.ctor} options.length should be a Number`;
            },
            get price() {
                return `${this.ctor} options.price should be a Number`;
            },
            get unit() {
                return `${this.ctor} options.unit should be a String with length`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { length, price, unit } = options;

        number(length, errorMessage.length, InvalidArgumentException);
        number(price, errorMessage.price, InvalidArgumentException);
        nonEmptyString(unit, errorMessage.unit, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Number}
         * @desc Length of intro period.
         *
         */
        this.length = length;

        /**
         *
         * @access public
         * @type {Number}
         * @desc Price during intro period. For free trials this would be 0.00.
         *
         */
        this.price = price;

        /**
         *
         * @access public
         * @type {String<SDK.Services.Paywall.TimeUnit>}
         * @desc Unit of time.
         *
         */
        this.unit = unit;

    }

}



// WEBPACK FOOTER //
// ./src/services/paywall/introPrice.js